var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-no-padding" }, [
          _c("form", { staticClass: "form" }, [
            _c("div", { staticClass: "form-row row" }, [
              _c("label", { staticClass: "col-12" }, [
                _vm._v(_vm._s(_vm.$t("plans.form.label"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.label,
                    expression: "label",
                  },
                ],
                ref: "label",
                staticClass: "form-input col-12",
                attrs: { type: "text" },
                domProps: { value: _vm.label },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.label = $event.target.value
                  },
                },
              }),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "Toolbar",
        { staticClass: "not-fixed" },
        [
          _c(
            "Btn",
            {
              staticClass: "primary",
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.valid($event)
                },
              },
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("global.save")) + "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "Btn",
            {
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.cancel($event)
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("global.cancel")) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }